const doubles: NodeList = document.querySelectorAll('.js-form-double-select');

export const DoubleForm = (double: HTMLElement) => {
  const parent = (double as HTMLSelectElement).querySelector(
    '.c-input--select--parent'
  ) as HTMLSelectElement;
  const child = (double as HTMLSelectElement).querySelector(
    '.c-input--select--child'
  ) as HTMLSelectElement;
  const Disabledevent = () => {
    if (parent.value == '未選択') {
      child.classList.add('js-form-disabled');
      child.disabled = true;
    } else {
      child.classList.remove('js-form-disabled');
      child.disabled = false;
    }
  };
  parent.addEventListener('change', () => {
    Disabledevent();
  });
  window.addEventListener('load', () => {
    Disabledevent();
  });
}

if (doubles) {
  doubles.forEach((double) => {
    DoubleForm(double as HTMLElement);
  });
};
